var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MyOrder"},[_c('ul',{staticClass:"tagList"},_vm._l((_vm.tagList),function(item,index){return _c('li',{key:'tag' + index,class:{ selected: _vm.form_head_uuid === item.form_head_uuid },on:{"click":function($event){return _vm.changeIndex(item.form_head_uuid)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.show)?[(
        [
          '403e15205bc248f48d8a3626571c4e56',
          '91e9bb4eac0a48b38e8327cc9c6c23de',
          '33d336e546644de7afb25e1989757d93'
        ].includes(_vm.form_head_uuid)
      )?_c('ApprovalList',{attrs:{"form_id":"436ae44d1c60475a9b4009ca40edc11e","form_head_uuid":_vm.form_head_uuid}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4e5234","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Purchase.vue
// module id = null
// module chunks = 